import { createListenerMiddleware } from "@reduxjs/toolkit";

import {
  setSessionUuid,
  setSport,
  setSportInitializedFromSocket,
} from "../slices/session";
import { addEventToQueue } from "../slices/socket";
import type { RootState } from "../store";

export const socketListener = createListenerMiddleware();

socketListener.startListening({
  actionCreator: setSessionUuid,
  effect: (action, listenerApi) => {
    const newUuid = action.payload;
    if (newUuid) {
      listenerApi.dispatch(setSportInitializedFromSocket(false));
    }
  },
});

socketListener.startListening({
  actionCreator: addEventToQueue,
  effect: async (action, listenerApi) => {
    const event = action.payload;

    if (!event?.ball || event.ball.trim() === "") return;

    const state = listenerApi.getState() as RootState;
    const { sportInitializedFromSocket } = state.session;

    if (sportInitializedFromSocket) return;

    const isSoftball = event.ball.toLowerCase().includes("softball");
    const newSport = isSoftball ? "softball" : "baseball";

    listenerApi.dispatch(setSport(newSport));
    listenerApi.dispatch(setSportInitializedFromSocket(true));
  },
});
